<script setup lang="ts">
export type SwitchValue = 'users' | 'groups';
import { useLocale } from '../composables/useLocale';

const { t } = useLocale();

defineProps<{ hideText?: boolean }>();

const model = defineModel<SwitchValue>({ default: 'users' });

defineEmits<{
  change: [type: SwitchValue];
}>();
</script>

<template>
  <v-btn-toggle
    class="w-100"
    v-model="model"
    :mandatory="true"
    rounded="lg"
    @update:model-value="(value: SwitchValue) => $emit('change', value)"
  >
    <v-btn
      class="w-50 user-group-toggle-btn"
      value="users"
      :prepend-icon="!hideText ? 'mdi-account' : ''"
      :aria-label="hideText ? t('lcp.users') : undefined"
    >
      <v-icon v-if="hideText">mdi-account</v-icon>
      {{ !hideText ? t('lcp.users') : '' }}
    </v-btn>
    <v-btn
      class="w-50 user-group-toggle-btn"
      value="groups"
      :prepend-icon="!hideText ? 'mdi-account-group' : ''"
      :aria-label="hideText ? t('lcp.groups') : undefined"
    >
      <v-icon v-if="hideText">mdi-account-group</v-icon>
      {{ !hideText ? t('lcp.groups') : '' }}
    </v-btn>
  </v-btn-toggle>
</template>

<style scoped lang="scss">
.user-group-toggle-btn {
  --v-activated-opacity: 0 !important; // required for exact color. There is $btn-toggle-selected-opacity but does not affect.

  :deep(.v-btn__overlay) {
    opacity: 0 !important;
  }
}
</style>
